import { ProtectedRoutesService, RoutingConfig, UrlParsingService } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { CsAgentAuthService } from '@spartacus/asm/root';

@Injectable({
    providedIn: 'root',
})
export class SikoProtectedRoutesService extends ProtectedRoutesService {
    constructor(
        protected config: RoutingConfig,
        protected urlParsingService: UrlParsingService,
        protected csAgentAuthService: CsAgentAuthService,
    ) {
        super(config, urlParsingService);
    }

    private reloaded = false;
    private unprotectedPaths: string[][] = [];

    reloadProtectedRoutes(): void {
        this.reloaded = true;
        this.unprotectedPaths = this.getNonProtectedPaths().map(path => this.getSegments(path));
    }

    /*
     * When a CS Agent is logged in, no URL is considered protected.
     * This mirrors the behaviour of Spartacus' AsmProtectedRoutesService so that
     * the agent can browse CMS pages freely without a customer emulation session
     */
    isUrlProtected(urlSegments: string[]): boolean {
        let isCsAgentLoggedIn = false;

        this.csAgentAuthService
            .isCustomerSupportAgentLoggedIn()
            .subscribe(result => (isCsAgentLoggedIn = result))
            .unsubscribe();

        if (isCsAgentLoggedIn) {
            return false;
        }

        if (!this.reloaded) {
            return super.isUrlProtected(urlSegments);
        }

        return this.shouldProtect && !this.matchAnyPath(urlSegments, this.unprotectedPaths);
    }
}
